var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMetricsScintillation = function SvgMetricsScintillation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M38.85 9.15 24 3 9.15 9.15 3 24l6.15 14.85L24 45l14.85-6.15L45 24zm-12.517 6.683C29.065 15.833 31 13.08 31 10c0 3.079 1.935 5.833 4.667 5.833-2.732 0-4.667 2.755-4.667 5.834 0-3.079-1.936-5.834-4.667-5.834M32.167 24c0 4.31-2.42 8.167-5.834 8.167 3.415 0 5.834 3.856 5.834 8.166 0-4.31 2.419-8.166 5.833-8.166-3.414 0-5.833-3.856-5.833-8.167m-24.5 0c4.778 0 8.166-5.509 8.166-11.667C15.833 18.491 19.222 24 24 24c-4.778 0-8.167 5.51-8.167 11.667C15.833 29.509 12.445 24 7.667 24",
    clipRule: "evenodd"
  })));
};
export default SvgMetricsScintillation;